import { Box, Typography } from "@mui/material";
import {
    Gamepad2,
    Footprints,
    ShoppingCart,
    Shirt,
    Clapperboard,
    Gem,
    Smartphone,
    Watch,
    HeartPulse,
    Armchair,
    Gift,
    GiftIcon,
    PartyPopper,
    Info,

} from "lucide-react";


const seoInfoData = [
    {
        category: "Gaming",
        title: "Buy Gift Cards Online in UAE",
        description:
            "Digital gift cards are a convenient gifting option for shoppers in the UAE. With 99gift.ae, customers can choose from available AED denominations and purchase digital gift cards online with convenient digital delivery.",
    },
    {
        category: "Footwear",
        title: "Perfect for Gifting & Every Occasion",
        description:
            "Digital gift cards can be a convenient choice for birthdays, Eid, celebrations, rewards, friends and family. Digital delivery makes gifting simple when you need a gift without waiting for physical delivery.",
    },
    {
        category: "E-Commerce",
        title: "Important Information",
        description:
            "Gift card redemption, availability, validity and account eligibility may be subject to the applicable brand's current terms and conditions. Please check the product information and applicable terms before purchasing.",
    },
    {
        category: "Apparel",
        title: "Perfect for Fashion & Gifting",
        description:
            "Give them the freedom to choose their favourite fashion and apparel products. A simple gifting option for birthdays, celebrations and special occasions.",
    },
    {
        category: "Entertainment",
        title: "Entertainment Made Easy",
        description:
            "Enjoy movies, shows, music and more with entertainment gift cards. A convenient gift option for anyone who loves to stay entertained.",
    },
    {
        category: "Jewellery",
        title: "A Special Gift for Jewellery Lovers",
        description:
            "Choose elegant jewellery gifts for every special occasion. Give your loved ones the freedom to select something that perfectly matches their style.",
    },
    {
        category: "Electronic",
        title: "Perfect for Electronics",
        description:
            "Shop for the latest electronics and gadgets with convenient digital gift cards. A great gifting choice for technology lovers.",
    },
    {
        category: "Accessories",
        title: "Perfect Accessories Gift",
        description:
            "Discover stylish accessories for every personality. Choose a thoughtful gift that lets them select something they truly love.",
    },
    {
        category: "Health",
        title: "A Thoughtful Health & Wellness Gift",
        description:
            "Choose health and wellness products that make everyday life better. A practical gifting option for friends and family.",
    },
    {
        category: "Furniture",
        title: "Perfect for Home & Furniture",
        description:
            "Give them the freedom to choose furniture and home products they love. A convenient gifting option for creating a comfortable home.",
    },
];


const categoryIcons = {
    Gaming: GiftIcon ,
    Footwear: PartyPopper,
    "E-Commerce": Info,
    Apparel: Shirt,
    Entertainment: Clapperboard,
    Jewellery: Gem,
    Electronic: Smartphone,
    Accessories: Watch,
    Health: HeartPulse,
    Furniture: Armchair,
};


const getCategoryIcon = (category) => {
    return categoryIcons[category] || Gift;
};

function ProdouctSeoInfo({ data = seoInfoData }) {
    return (
        <Box
            component="section"
            sx={{
                width: "100%",
                overflow: "hidden",
                border: "1px solid",
                borderColor: "#F0F0F0",
                borderRadius: "12px",
                backgroundColor: "#FFFFFF",
            }}
        >
            <Box
                sx={{
                    display: "grid",
                    gridTemplateColumns: {
                        xs: "1fr",
                        sm: "repeat(3, 1fr)",
                    },
                }}
            >
                {data.slice(0, 3).map((item, index) => {
                    const Icon = getCategoryIcon(item?.category);

                    return (
                        <Box
                            key={`${item.category}-${index}`}
                            sx={{
                                minWidth: 0,
                                px: {
                                    xs: 3,
                                    sm: 2.5,
                                    md: 3,
                                },
                                py: {
                                    xs: 3,
                                    sm: 2.5,
                                    md: 3,
                                },

                                textAlign: "center",

                                borderRight: {
                                    xs: "none",
                                    sm:
                                        index !== 2 ? "1px solid #EEEEEE" : "none",
                                },

                                borderBottom: {
                                    xs:
                                        index !== Math.min(data?.length, 3) - 1
                                            ? "1px solid #EEEEEE"
                                            : "none",
                                    sm: "none",
                                },
                            }}
                        >
                            {/* Icon */}
                            <Box
                                sx={{
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    mb: 1.5,
                                }}
                            >
                                <Icon
                                    size={30}
                                    strokeWidth={1.8}
                                    color="#002865"
                                />
                            </Box>

                            {/* Title */}
                            <Typography
                                component="h3"
                                sx={{
                                    color: "primaryDark.main",
                                    fontSize: {
                                        xs: "13px",
                                        sm: "12px",
                                        md: "13px",
                                    },
                                    fontWeight: 700,
                                    lineHeight: 1.35,
                                    mb: 1.25,
                                    fontFamily: "Be Vietnam Pro",
                                }}
                            >
                                {item?.title}
                            </Typography>

                            {/* Description */}
                            <Typography
                                component="p"
                                sx={{
                                    maxWidth: "310px",
                                    mx: "auto",
                                    color: "#000",
                                    fontSize: {
                                        xs: "11px",
                                        sm: "10px",
                                        md: "11px",
                                    },
                                    fontWeight: 400,
                                    lineHeight: 1.7,
                                    m: 0,
                                    fontFamily: "Be Vietnam Pro",
                                }}
                            >
                                {item?.description}
                            </Typography>
                        </Box>
                    );
                })}
            </Box>
        </Box>
    );
}

export default ProdouctSeoInfo;